import React, { useState, useEffect, useCallback, useMemo } from "react";
import { getPartyDetails, addNewParty, deleteParyDetails, editParyDetails } from "../../util/APIUtils";
import "react-datepicker/dist/react-datepicker.css";
import { LoadingOverlay } from "../../util/Helpers";
import PartyDetailsBody from "./PartyDetailsBody";
import AddPartyForm from "./AddPartyForm";
import { CardBody, CardHeader, Card } from "reactstrap";
import { Button } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import ModalForm from "./ModalForm";
import { ButtonStyles } from "../../constants/ButtonStyles";

export default function PartyDetails() {
    const [block, setBlock] = useState(false);
    const [parties, setParties] = useState([]);
    const [flag, setFlag] = useState(false);
    const [values, setValues] = useState({});
    const [modal, setModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [restRow, setRestRow] = useState(null);
    const [uniqBeatName, setUniquBeatName] = useState([])

    const formFields = [
        { id: 1, label: "Party Name", name: "customerName", type: "text", readOnly: true, required: true },
        { id: 2, label: "Address", name: "address", type: "textarea", readOnly: true, required: true },
        // { id: 3, label: "Contact No", name: "mobileNumber", type: "text", readOnly: true, required: true },
        // { id: 4, label: "city", name: "city", type: "text", readOnly: false, required: true },
        // { id: 5, label: "pinCode", name: "pinCode", type: "text", readOnly: true, required: true },
        // { id: 6, label: "GST Number", name: "cigstNumberty", type: "text", readOnly: true, required: true },
        {
            id: 7,
            label: "Beat Name",
            name: "beatName",
            type: "select",
            readOnly: false,
            required: true,
            options: uniqBeatName.map((beat) => ({ label: beat, value: beat }))
        },
        {
            id: 8,
            label: "Update all invoices",
            name: "updateAllinovice",
            type: "checkbox",
            readOnly: false,
            required: false,
            defaultChecked: false
        },
    ];


    useEffect(() => {
        loadReqData();
    }, []);

    const loadReqData = () => {
        setBlock(true);
        getPartyDetails().then((response) => {
            setParties(response);
            const uniqueBeatNames = [...new Set(response.map(item => item.beatName).filter(Boolean))];
            setUniquBeatName(uniqueBeatNames);
            setBlock(false);
        });
    };

    const onChangeForm = useCallback(({ target: { name, value } }) => {
        setValues((prevValues) => ({
            ...prevValues,
            [name]: value,
        }));
    }, []);

    const addParty = (data) => {
        setBlock(true);
        addNewParty(data).then((response) => {
            setBlock(false);
            changeFlag();
            loadReqData();
        });
    };

    const updateDetails = useCallback((row) => {
        toggleModal();
        setSelectedRow(row);
        setRestRow(row);
    }, [uniqBeatName]);

    const handleInputChange = useCallback(({ target: { name, value } }) => {
        if (!selectedRow) return;
        setSelectedRow((prevRow) => ({
            ...prevRow,
            [name]: value,
        }));
    }, [selectedRow]);


    const toggleModal = useCallback(() => setModal((prev) => !prev), []);

    const viewDetails = (row) => {
        setBlock(true);
        editParyDetails(row).then((response) => {
            setBlock(false);
            loadReqData();
        });

    };

    const deleteParty = (row) => {
        setBlock(true);
        deleteParyDetails(row).then((response) => {
            setBlock(false);
            loadReqData();
        });
    };

    const onSubmit = () => {
        setBlock(true);
        // Ensure updateAllinovice is present in selectedRow (default to false if undefined)
        const updatedRow = {
            ...selectedRow,
            updateAllinovice: selectedRow && typeof selectedRow.updateAllinovice !== 'undefined' ? selectedRow.updateAllinovice : false
        };
        editParyDetails(updatedRow).then((response) => {
            setBlock(false);
            toggleModal();
            loadReqData();
        });
    };
    const changeFlag = () => {
        setFlag(!flag);
    };

    const memoizedParties = useMemo(() => parties, [parties]);
    const onCancel = () => {
        setSelectedRow(restRow);
    };

    return (
        <div className="animated fadeIn">
            {block && <LoadingOverlay />}
            <ModalForm isOpen={modal} toggle={toggleModal} title={'Update Party details'} formFields={formFields} selectedRow={selectedRow} handleInputChange={handleInputChange} onSubmit={onSubmit} onCancel={onCancel} />
            {flag ? (
                <Card style={{
                    borderRadius: "15px",
                    boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                    border: "none",
                    overflow: "hidden"
                }}>
                    <CardHeader style={{
                        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                        padding: "20px 25px",
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderBottom: "none"
                    }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <i className="fa fa-user-plus" style={{ fontSize: "24px", color: "#fff" }}></i>
                            <strong style={{ fontSize: '1.2rem', color: "#fff" }}>Add Party</strong>
                        </div>
                        <Button color="secondary" onClick={() => changeFlag()} style={{
                            background: "rgba(255,255,255,0.2)",
                            border: "1px solid rgba(255,255,255,0.3)",
                            borderRadius: "8px",
                            color: "#fff"
                        }}>
                            <FaArrowLeft /> Back
                        </Button>
                    </CardHeader>
                    <CardBody style={{ padding: "25px" }}>
                        <AddPartyForm addParty={addParty} onChangeForm={onChangeForm} values={values} />
                    </CardBody>
                </Card>
            ) : (
                <span>
                    <PartyDetailsBody
                        data={memoizedParties}
                        updateDetails={updateDetails}
                        changeFlag={changeFlag}
                        deleteParty={deleteParty}
                    />
                </span>
            )}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/CustomComponents/PartyDetails.js